module.exports = __webpack_public_path__ + "static/media/35-iveco-mercedes.d64a2a14.jpg";